import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { CREATE_PARENT_PROJECT, CREATE_PARENT_PROJECT_SUCCESS, CREATE_PARENT_PROJECT_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* createParentProject({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/parent-projects`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`Project created successfully`);
      yield put({
        type: CREATE_PARENT_PROJECT_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CREATE_PARENT_PROJECT_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_PARENT_PROJECT_ERROR, payload: error });
  }
}

export function* watchCreateParentProject() {
  yield takeEvery(CREATE_PARENT_PROJECT, createParentProject);
}

function* createParentProjectSaga() {
  yield all([fork(watchCreateParentProject)]);
}

export default createParentProjectSaga;
